<app-material>
    <div class="header" header>
        <h2>{{ 'admin.equipment.processTypes.table.title' | translate }}</h2>
        <div class="mutators">
            <app-button *ngIf="shouldRenderModifiers()"
                        (click)="openProcessTypeModal()">
                {{ 'admin.equipment.processTypes.buttons.addProcessType' | translate }}
            </app-button>
        </div>
    </div>
    <ng-container body>
        <app-process-types-table [processTypes]="processTypes"
                                 [tableConfig]="tableConfig"
                                 [hasTitle]="false"
                                 [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                                 [isLoading]="isLoadingProcessTypes"
                                 (sortChange)="onSortChange($event)"
                                 (rowClick)="onTableRowClick($event)"
                                 (filterChange)="onFilter($event)"
                                 (pageChange)="onPageChange($event)">
        </app-process-types-table>
    </ng-container>
</app-material>
<app-process-type-create-modal
    [isLoading]="isLoadingProcessTypes"
    (onCreate)="createProcessType($event)"
    (onUpdate)="updateProcessType($event)"
    (onDelete)="deleteProcessType($event)">
</app-process-type-create-modal>
